import { useState } from 'react';
import type { CreateOrganizationRelationshipResponseDto } from '@evimo/client/models/CreateOrganizationRelationshipResponseDto';
import { useOrganizationRelationships } from '~/app/hooks/organisationRelationship/useOrganizationRelationships';
import type { FormValues } from '~/app/components/organizationRelationship/RelationshipModal';
import { OrganizationRelationshipPageView } from './OrganizationRelationshipPageView';

export function OrganizationRelationshipPageContainer() {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedParentId, setSelectedParentId] = useState<string | null>(null);
  const [editingRelationship, setEditingRelationship] =
    useState<CreateOrganizationRelationshipResponseDto | null>(null);

  const closeModal = (): void => {
    setModalOpen(false);
    setEditingRelationship(null);
  };

  const {
    isLoading,
    orgMap,
    orgOptions,
    relationships,
    organizations,
    createMutation,
    updateMutation,
    deleteMutation,
  } = useOrganizationRelationships(closeModal);

  const filteredRelationships = selectedParentId
    ? relationships.filter(
        (relationship) => relationship.orgId === selectedParentId,
      )
    : [];

  const handleOpenCreate = (): void => {
    setEditingRelationship(null);
    setModalOpen(true);
  };

  const handleOpenEdit = (
    relationship: CreateOrganizationRelationshipResponseDto,
  ): void => {
    setEditingRelationship(relationship);
    setModalOpen(true);
  };

  const handleSubmit = (
    values: FormValues,
    editingValue: CreateOrganizationRelationshipResponseDto | null,
  ): void => {
    if (editingValue) {
      updateMutation.mutate({
        id: editingValue.id,
        dto: { ...values, id: editingValue.id },
      });
      return;
    }

    createMutation.mutate(values);
  };

  return (
    <OrganizationRelationshipPageView
      editingRelationship={editingRelationship}
      filteredRelationships={filteredRelationships}
      isDeleting={deleteMutation.isPending}
      isLoading={isLoading}
      isSubmitting={createMutation.isPending || updateMutation.isPending}
      modalOpen={modalOpen}
      onCloseModal={closeModal}
      onDelete={(id) => deleteMutation.mutate(id)}
      onOpenCreate={handleOpenCreate}
      onOpenEdit={handleOpenEdit}
      onSelectedParentChange={setSelectedParentId}
      onSubmit={handleSubmit}
      organizations={organizations}
      orgMap={orgMap}
      orgOptions={orgOptions}
      relationships={relationships}
      selectedParentId={selectedParentId}
    />
  );
}
